export default __webpack_public_path__ + "static/media/community-blob.4597cd92.jpg";